<template>
  <div class="smaller-container-wrapper full-height no-progress-bar pb-0">
    <MobialisFormWithValidation
      @onValidate="submit"
      novalidate
      v-av-analytics-form-submit="{ elementText: $t('message.eCommerceV2.credit.applyToPayment') }"
    >
      <h2 class="mb-4 pt-4">{{ $t('message.eCommerceV2.credit.selectCreditTitle') }}</h2>
      <div class="row form-row pb-2 pt-2">
        <div class="col-12" v-for="(option, index) in creditRanges" :key="index">
          <MobialisFancyRadio
            rules="required"
            :textArray="[option]"
            name="creditRangeOptions"
            v-model="creditRange"
            :data-cy="option.value"
          ></MobialisFancyRadio>
        </div>
      </div>
      <p class="text-danger small my-0" v-if="!isValid">{{ $t('message.eCommerceV2.pleaseSelect') }}</p>
      <mobialis-button type="submit" class="mt-4 mb-5 mb-sm-4" data-cy="applyToPayment">{{
        $t('message.eCommerceV2.credit.applyToPayment')
      }}</mobialis-button>
    </MobialisFormWithValidation>
    <!-- If user has already tried to check credit and it failed don't let them do it again -->
    <div v-if="!creditChecksFailed">
      <div class="avr-card px-4 pb-3 pb-sm-3 pt-3 pt-sm-1 text-sm-center mb-3">
        <img
          class="tu-logo mx-sm-auto my-3"
          :src="require(`@/assets/credit-bureaus/${getDefaultCreditDataSourceCAName.logoName}`)"
          :alt="getDefaultCreditDataSourceCAName.niceName"
        />
        <h3 class="mt-0 mb-3">{{ $t('message.eCommerceV2.credit.introCardTitle') }}</h3>
        <p class="intro-card-text mb-1 mt-0 px-sm-5">{{ $t('message.eCommerceV2.credit.introCardText') }}</p>
        <div class="btn-container">
          <mobialis-button
            variant="secondary"
            :width="isDesktopSize ? 'w-auto' : 'w-100'"
            type="button"
            class="mt-4 mb-4 mb-sm-4"
            :size="isDesktopSize ? 'btn-md' : 'btn-lg'"
            @click="getCreditRange"
            data-cy="goToCredit"
            v-av-analytics-cta-interaction="{
              elementText: $t('message.eCommerceV2.credit.introCardButton'),
              eventActionResult: 'open',
            }"
            >{{ $t('message.eCommerceV2.credit.introCardButton') }}</mobialis-button
          >
        </div>
      </div>
      <p v-if="isEquifax" class="mt-0 font-size-10 color-primary-grey">{{ $t('message.credit.disclaimer.equifax') }}</p>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/fp/cloneDeep';
import { mapState, mapGetters } from 'vuex';
import { CreditDataSourceCA } from '@/utils/enums';

export default {
  name: 'SelectCreditRange',
  data() {
    return {
      isValid: true,
      creditRange: cloneDeep(this.$store.state.paymentCalculator.selectedCreditRange),
      creditRanges: this.$t('message.eCommerceV2.credit.creditRanges'),
      isDesktopSize: false,
    };
  },
  computed: {
    ...mapState('credit', ['creditChecksFailed']),
    ...mapGetters(['getCurrentProduct']),
    ...mapGetters('ecommerceV2', ['getDefaultCreditDataSourceCAName']),
    ...mapGetters('business', ['getDefaultCreditDataSourceCA']),
    isEcomV2() {
      return this.getCurrentProduct === this.enums.AVRProducts.ECOMV2;
    },
    isEquifax() {
      return this.getDefaultCreditDataSourceCA === CreditDataSourceCA.EQUIFAX;
    },
  },
  mounted() {
    window.addEventListener('resize', this.checkMediaQuery, false);
    this.checkMediaQuery();
  },
  destroyed() {
    window.removeEventListener('resize', this.checkMediaQuery, false);
  },
  methods: {
    async submit(isValid) {
      if (!isValid) {
        this.isValid = false;
        return;
      }
      this.isValid = true;
      this.$store.commit('paymentCalculator/SET_STATE', ['selectedCreditRange', this.creditRange]);
      if (this.isEcomV2) {
        this.$router.push('../payment-calculator');
      } else {
        this.$router.push('../payment-summary');
      }
    },
    checkMediaQuery() {
      this.isDesktopSize = window.matchMedia('(min-width: 576px)').matches;
    },
    getCreditRange() {
      this.$router.push('credit-intro');
    },
  },
};
</script>

<style scoped lang="scss">
.card {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
}
.tu-logo {
  width: 95px;
  height: auto;
}
.intro-card-text {
  color: #19222b;
}
.find-out {
  border: none;
  background: #f0f4f7;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;

  @media (min-width: 576px) {
    padding: 6px 30px;
  }
}
</style>
